import React, { Component } from 'react';
import Truncate from 'react-truncate';
import { withRouter } from 'react-router-dom';
import { Draggable } from 'react-beautiful-dnd';
import { Translation } from 'react-i18next';
import InformationIcon from '../utility/InformationIcon';
import CancelIcon from '../utility/CancelIcon';
import { modalOpen_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import Favorite from '../utility/Favorite';
import SunIcon from '../utility/SunIcon.jsx';

class Top25CareerCard extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      displayDropDown: false,
    };
    this[`draggable${this.props.index1Through25}`] = React.createRef();
    this.overlay = React.createRef();
  }

  secondaryBorderBottom = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  secondaryBorder = {
    border: `5px solid ${this.props.tenant.secondary}`,
  };

  backgroundPrimary = {
    backgroundColor: this.props.tenant.primary,
  };

  displayNone = {
    display: 'none',
  };

  componentDidMount = () => {
    window.addEventListener('click', this.handleClickOutside);
  };

  handleClickOutside = (e) => {
    if (this.state.displayDropDown && typeof e.target.className === 'string') {
      if (
        !e.target.className.includes('add-button') &&
        !e.target.className.includes('top-3-dropdown')
      ) {
        this.setState({
          displayDropDown: false,
        });
      }
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('click', this.handleClickOutside);
  };

  careerImage = this.props.career.image
    ? this.props.career.image
    : this.props.career.categoryImageVariant;

  handleInfoButtonSelected = () => {
    this.props.history.push(
      `${this.props.location.pathname}?career=${encodeURIComponent(
        this.props.career.titleEn
      )}`
    );
  };

  handleDisplayDropDown = () => {
    this.setState((prevState) => {
      return { displayDropDown: !prevState.displayDropDown };
    });
  };

  handleAddCareer = async (stateVal) => {
    await this.props.handleDragStart(this.props.sourceList, this.props.index);
    await this.props.onDrop(stateVal);
    this.setState({
      displayDropDown: false,
    });
  };

  render() {
    const { index, sourceList, career, index1Through25 } = this.props;
    return (
      <Translation>
        {(t) => (
          <div
            className="draggable-career"
            draggable="true"
            ref={this[`draggable${index1Through25}`]}
            onDragOver={(e) => {
              e.preventDefault();
              if (sourceList !== 'otherCareers') {
                this.overlay.current.classList.remove(
                  'draggable-career__display-none'
                );
              }
            }}
            onDragStart={(e) => {
              this[`draggable${index1Through25}`].current.classList.add(
                'draggable-career__dragging'
              );
              e.stopPropagation();
              this.props.handleDragStart(sourceList, index);
            }}
            onDragEnd={() => {
              this[`draggable${index1Through25}`].current.classList.remove(
                'draggable-career__dragging'
              );
            }}
          >
            <div
              aria-hidden="true"
              onDrop={() => {
                this.overlay.current.classList.add(
                  'draggable-career__display-none'
                );
                this.props.onDrop(sourceList);
              }}
              onDragLeave={() => {
                this.overlay.current.classList.add(
                  'draggable-career__display-none'
                );
              }}
              ref={this.overlay}
              className="draggable-career__drag-here-overlay draggable-career__display-none"
              style={this.secondaryBorder}
            >
              {`${t('Drag Career Here')} +`}
            </div>
            <img
              src={career.image ? career.image : career.categoryImageVariant}
              alt={`${t('Top Chosen Career: Career Choice {{choiceNumber}}:', {
                choiceNumber: index1Through25,
              })} ${career.titleEn}`}
              className="draggable-career__career-image"
              data-cy="career-picture-results"
              draggable="false"
              width="800"
              height="400"
            />
            <div className="draggable-career__favorite-container">
              <Favorite
                careerId={career.id}
                careerName={career.titleEn}
                career={career}
              />
            </div>
            <div
              style={this.secondaryBorderBottom}
              className="draggable-career__career-content"
              data-cy="career-content-top-draggable"
            >
              <p
                className="draggable-career__truncated-class-text"
                data-cy="career-title"
              >
                {career.titleEn}
              </p>
              {this.props.sourceList !== 'otherCareers' && (
                <button
                  type="button"
                  id={`close-${career.titleEn}`}
                  aria-label={t(
                    'Click to remove {{careerTitle}} from your top 3. Removing this career will drop it down to the bottom of your career options list.',
                    { careerTitle: career.titleEn }
                  )}
                  className="draggable-career__x-icon"
                  onClick={() => this.props.removeFromTopThree(sourceList)}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.key))
                      this.props.removeFromTopThree(sourceList);
                  }}
                  tabIndex={0}
                >
                  <CancelIcon color={this.props.tenant.primary} />
                </button>
              )}
              <div className="draggable-career__buttons-container">
                <button
                  type="button"
                  style={this.backgroundPrimary}
                  className="draggable-career__add-button"
                  aria-label={this.props.addButtonAriaLabel}
                  aria-expanded={this.state.displayDropDown}
                  tabIndex={0}
                  onClick={() => {
                    this.handleDisplayDropDown();
                  }}
                >
                  {this.props.addButtonLabel}
                </button>
                {this.state.displayDropDown && (
                  <div className="draggable-career__top-3-dropdown">
                    {[1, 2, 3].map((i) => {
                      return (
                        <button
                          tabIndex={0}
                          key={`dropdown-option-${i}`}
                          type="button"
                          onClick={() => {
                            this.handleAddCareer(`career${i}`);
                          }}
                          aria-label={t(
                            `Click to add {{itemTitle}} to space number {{number}}`,
                            { itemTitle: career.titleEn, number: i }
                          )}
                          onKeyDown={(e) => {
                            if (['Enter'].includes(e.key)) {
                              return this.handleAddCareer(`career${i}`);
                            }
                          }}
                          className="draggable-career__top-3-dropdown-option"
                        >
                          {t('Career Spot {{number}}', { number: i })}
                        </button>
                      );
                    })}
                  </div>
                )}
                <div className="draggable-career__outlook-info-icon">
                  {career.careerOutlook && (
                    <SunIcon
                      additionalClassName="draggable-careers"
                      setParentOnClick={this.props.setBrightOutlookModal}
                    />
                  )}
                  <div
                    data-cy="info-button"
                    id={`info-${career.titleEn}`}
                    className="draggable-career__info-button"
                  >
                    <InformationIcon
                      color={this.props.tenant.primary}
                      gtmObj={modalOpen_GTM}
                      parentOnClickHandler={this.handleInfoButtonSelected}
                      section={career.titleEn}
                      ariaLabel={t(
                        `click to open information modal for {{itemTitle}}`,
                        { itemTitle: career.titleEn }
                      )}
                      modalImage={this.careerImage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Top25CareerCard);
